import { getBulkLogisticsPackaging } from "@/api/template";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileUploader from "@/components/FileUploader/FileUploader";
import PackageIcon from "@/components/icons/chapters/PackageIcon";

function UploadLogisticsPackaging({ year }: { year?: number }) {
  return (
    <FileUploader
      uploadType={"logistics_packaging"}
      buttonText={""}
      templateUrlFn={getBulkLogisticsPackaging}
      uploadDataTableProps={{
        columns: [
          { key: "facility_name", label: "Facility name" },
          { key: "material_name", label: "Material" },
          { key: "mass", label: "Mass (kg)" },
          { key: "supplier_name", label: "Supplier name" },
          { key: "supplier_address", label: "Supplier address" },
        ],
        rowKey: "material_name",
      }}
      uploadParameters={{
        year: year,
      }}
      customRender={(props) => (
        <ActionsPopOverItem
          icon={
            <PackageIcon
              width={14}
              height={14}
            />
          }
          black
          {...props}
        >
          Logistics packaging
        </ActionsPopOverItem>
      )}
    />
  );
}

export default UploadLogisticsPackaging;
